// =====================================
//	ATM付款跳窗文案
//	@author: Alan
//	@time 2016 / 06 / 23
// =====================================

window.InifECApp.directive('atmNotification', ['$rootScope', '$ngModal', '$state', function ($rootScope, $ngModal, $state) {

	var _dir = {};

	var controller = ['$scope', function($scope) {

        // ===============================
        //  開啟 modal
        // ===============================
        var openModal = function() {
        	$ngModal.openModal('atm-notification-modal');
        }

        // ===============================
        //  關閉 modal
        // ===============================
        var closeModal = function() {
        	$ngModal.closeModal('atm-notification-modal');
        }

        var goToOrderInfo = function() {
            $state.go(window.STATES.PAYMENT, {orderid: $scope.orderid});
            closeModal();

        }

        /*==========================
            Events
        ==========================*/            
        $scope.$on('OPEN_ATM_NOTIFICATION_MODAL', function(event, data) {

            if(data) {
                $scope.orderid = data.orderid;
                openModal();
            }
        });

        /*==========================
            Members
        ==========================*/

        /*==========================
            Methods
        ==========================*/
        $scope.closeModal = closeModal;
        $scope.goToOrderInfo = goToOrderInfo;
        
        /*==========================
            init
        ==========================*/
        
	}]

	_dir.restrict = "E";
	_dir.scope = true;
	_dir.templateUrl = "partials/modal/atm_notification.html";
	_dir.controller = controller;

	return _dir;
}]);